module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"contact":{"email":"Email Address","name":"Name","title":"Message Subject","content":"Message Content","send":"Send Message","placeholders":{"name":"Enter Your Name","email":"Enter Your Email Address","title":"Enter Message Subject","content":"Enter Message Content"}}}}')
  delete Component.options._Ctor
}
